import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import ForgotPassword from "../pages/Authorization/ForgotPassword";
import { roles } from "../pages/utils/constant";
import SendOTP from "../pages/Authorization/SendOTP";
import ChangePassword from "../pages/Authorization/ChangePassword";
import OfficeList from "../pages/SuperAdmin/OfficeManagement/OfficeList";
import NewOffice from "../pages/SuperAdmin/OfficeManagement/NewOffice";
import BranchList from "../pages/SuperAdmin/BranchManagement/BranchList";
import NewBranch from "../pages/SuperAdmin/BranchManagement/NewBranch";
import BillingList from "../pages/SuperAdmin/BillingManagement/BillingList";
import NewBilling from "../pages/SuperAdmin/BillingManagement/NewBilling";
import NewPickup from "../pages/SuperAdmin/PickupManagment/NewPickup";
import CreateFromPickup from "../pages/OfficeAdmin/Pickup/CreateFromPickup"
import PickupList from "../pages/SuperAdmin/PickupManagment/PickupList";
import DeliveryBoyList from "../pages/SuperAdmin/DeliveryBoyManagement/DeliveryBoyList";
import NewDeliveryBoy from "../pages/SuperAdmin/DeliveryBoyManagement/NewDeliveryBoy";
import ResetPassword from "../pages/Authorization/ResetPassword";
import DocketList from "../pages/SuperAdmin/DocketManagement/DocketList";
import DocketTracking from "../pages/SuperAdmin/DocketManagement/DocketTracking";
import NewPOD from "../pages/OfficeAdmin/POD/newPod";
import PODList from "../pages/OfficeAdmin/POD/PODList";
import ReportList from "../pages/SuperAdmin/Report/ReportList";
import DocketPDF from "../components/Custom/DocketpdfMake";
import DocketFormate from "../pages/SuperAdmin/DocketManagement/DocketFromate";
import InscanFormat from "../pages/OfficeAdmin/Inscan/InscanFormat";
import DrsFormat from "../pages/OfficeAdmin/DRS/DRSFromat";
const DashBoard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const SignIn = React.lazy(() => import("../pages/Authorization/SignIn"));
const Shared = React.lazy(() => import("./Shared"));
const CustomerList = React.lazy(() => import("../pages/SuperAdmin/CustomerManagement/CustomerList"));
const NewCustomer = React.lazy(() => import("../pages/SuperAdmin/CustomerManagement/NewCustomer"));
const PickupAllocated = React.lazy(()=>import("../pages/OfficeAdmin/Pickup/PickupAllocated"));
const PickupPending = React.lazy(()=>import("../pages/OfficeAdmin/Pickup/PickupPending"))
const CreateManifest = React.lazy(()=>import("../pages/OfficeAdmin/Manifest/CreateManifest"))
const ViewManifest =React.lazy(()=>import("../pages/OfficeAdmin/Manifest/ViewManifest"))
const CreateInscan = React.lazy(() => import("../pages/OfficeAdmin/Inscan/CreateInscan"))
const ViewInscan = React.lazy(() => import("../pages/OfficeAdmin/Inscan/ViewInscan"))
const ViewDRS = React.lazy(() => import("../pages/OfficeAdmin/DRS/ViewDRS"))
const NewDRS = React.lazy(() => import("../pages/OfficeAdmin/DRS/NewDRS"))
const DeliveryPickup = React.lazy(() => import("../pages/SuperAdmin/DeliveryManagement/Pickup")) 



const ProtectedRoute = () => {
  // const userDetails =  [{Role:'Admin'}]
  let userDetails = null;
try {
  const raw = localStorage.getItem("userdetails");
  if (raw && raw !== "undefined") {
    userDetails = JSON.parse(raw);
  }
} catch (error) {
  console.error("Invalid JSON in localStorage for 'userdetails':", error);
}

  
  function setRoutes() {
    switch (userDetails?.Role) {
      case roles.Admin:
        return (
          <>
          {/* Customer Management */}
            <Route path="/dashboard/customerlist" element={<CustomerList />} />
            <Route path="/dashboard/customerlist/newcustomer" element={<NewCustomer />} />

          {/* Office Management */}
            <Route path="/dashboard/officelist" element={<OfficeList />} />
            <Route path="/dashboard/officelist/newoffice" element={<NewOffice />} />

          {/* Branch Management */}
          <Route path="/dashboard/branchlist" element={<BranchList />} />
          <Route path="/dashboard/branchlist/newbranch" element={<NewBranch />} />

          {/* Deliver Boy Management */}
          <Route path="/dashboard/deliveryboylist" element={<DeliveryBoyList />} />
          <Route path="/dashboard/deliveryboylist/newdeliveryboy" element={<NewDeliveryBoy />} />

          {/* Bill Management */}
          <Route path="/dashboard/billinglist" element={<BillingList />} />
          <Route path="/dashboard/billinglist/newbilling" element={<NewBilling />} />

          {/* Pickup Management */}
          {/* <Route path="/dashboard/createform" element={<CreateFromPickup />} /> */}
          <Route path="/dashboard/pickuplist" element={<PickupList />} />
          <Route path="/dashboard/pickuplist/newpickup" element={<NewPickup />} />

         {/* Manifest Management */}
          <Route path="/dashboard/manifestList/create-manifest" element={<CreateManifest />} />
          <Route path="/dashboard/manifestList" element={<ViewManifest />} />

          {/*========== Inscan Management ============= */}
          <Route path="/dashboard/viewlist" element={<ViewInscan />} />
          <Route path="/dashboard/viewlist/newinscan" element={<CreateInscan />} />
          <Route path="/dashboard/viewlist/inscanformat" element={<InscanFormat/>}/>
          {/* <Route path="/dashboard/view-inscan" element={<ViewInscan />} /> */}

          {/* ================= DRS Management ==================*/}
          <Route path="/dashboard/drslist" element={<ViewDRS />} />
          <Route path="/dashboard/drslist/newdrs" element={<NewDRS />} />
          <Route path="/dashboard/drslidt/drsformat" element={<DrsFormat/>}/>

        {/* ================= Docket Management ==================*/}
          <Route path="/dashboard/docketlist" element={<DocketList />} />
          <Route path="/dashboard/docketlist/docketview" element={<DocketTracking />} />
          <Route path="/dashboard/docketlist/docketformat" element={<DocketFormate />} />
          <Route path="/dashboard/docketlist/docketpdf" element={<DocketPDF />} />
          
        {/* ================= POD Management ================== */}
          <Route path="/dashboard/podlist/newpod" element={<NewPOD/>}/>
          <Route path="/dashboard/podlist" element={<PODList/>}/>

        {/* ===================== Report ============================== */}
          <Route path="/dashboard/reportlist" element={<ReportList/>}/>
          
          {/* ===================== Delivery Management ==================*/}
          {/* <Route path="/dashboard/deliverymanagement" element={<DeliveryManagement />} /> */}
          <Route path="/dashboard/deliverymanagement" element={<DeliveryPickup />} />
          </>
        );
   
      case roles.OfficeAdmin:
        return (
          <>
            {/* Pickup Management */}
            <Route path="/dashboard/createform" element={<CreateFromPickup />} />
            <Route path="/dashboard/pickup-allocated" element={<PickupAllocated />} />
            <Route path="/dashboard/pickup-pending" element={<PickupPending />} />

            {/* Manifest Management */}
            <Route path="/dashboard/manifestList/create-manifest" element={<CreateManifest />} />
            <Route path="/dashboard/manifestList" element={<ViewManifest />} />

            {/* Inscan Management */}
            <Route path="/dashboard/viewlist" element={<ViewInscan />} />
            <Route path="/dashboard/viewlist/newinscan" element={<CreateInscan />} />
            <Route path="/dashboard/viewlist/inscanformat" element={<InscanFormat/>}/>

            {/* DRS Management */}
            <Route path="/dashboard/drslist" element={<ViewDRS />} />
            <Route path="/dashboard/drslist/newdrs" element={<NewDRS />} />
            <Route path="/dashboard/drslidt/drsformat" element={<DrsFormat/>}/>

            {/* POD Management */}
            <Route path="/dashboard/podlist/newpod" element={<NewPOD/>}/>
            <Route path="/dashboard/podlist" element={<PODList/>}/>

            {/* ===================== Report ============================== */}
            <Route path="/dashboard/reportlist" element={<ReportList/>}/>

          </>
        );

      default:
        return null;
    }
  }

  return (
    <>
      <Routes>
        <>
          {/* Authoriszation Routes */}
          <Route path="/" element={<SignIn />} />
          <Route path="/sendotp" element={<SendOTP/>} />
          <Route path="/forgotpassword" element={<ForgotPassword />} /> 
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/resetpassword" element={<ResetPassword/>} />
          <Route path="/dashboard" element={<Shared />}>
            <Route index element={<DashBoard />} />
            {setRoutes()}
          </Route>
        </>
      </Routes>
    </>
  );
};

export default ProtectedRoute;
